/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
import './MenuNavigationMobile.scss';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
function MenuNavigationMobile(_ref) {
  var {
    onCategorySelect,
    categories: propCategories,
    activeCategory
  } = _ref;
  var {
    language
  } = useLanguage();
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState(null);
  var [categories, setCategories] = useState([]);
  var scrollContainerRef = useRef(null);
  var [isDragging, setIsDragging] = useState(false);
  var [startX, setStartX] = useState(0);
  var [scrollLeft, setScrollLeft] = useState(0);
  var GET_ALL_CATEGORIES = "\n    query {\n      categories {\n        items {\n          name\n          nameAr\n          urlKey\n        }\n      }\n    }\n  ";
  useEffect(() => {
    // If categories are provided as props, use them
    if (propCategories && propCategories.length > 0) {
      setCategories(propCategories);
      setLoading(false);
      return;
    }

    // Otherwise fetch categories
    var fetchCategories = async () => {
      try {
        var response = await fetch('/api/graphql', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            query: GET_ALL_CATEGORIES
          })
        });
        var result = await response.json();
        if (result.errors) {
          throw new Error(result.errors[0].message);
        }

        // Filter out categories that contain "2nd Side" or "1st Side"
        var filteredCategories = result.data.categories.items.filter(category => !/^(2nd Side|1st Side)$/i.test(category.name));

        // Define the desired order of categories
        var categoryOrder = ['Appetizers', 'Salads', 'Pasta', 'Asian', 'Rice Dishes', 'Oriental Meals', 'Main Dishes', 'Sandwiches', 'Pizzas', 'Desserts', 'Side items', 'Sauces', 'Combo', 'Soft Drinks'];

        // Sort the categories based on the defined order
        var sortedCategories = [...filteredCategories].sort((a, b) => {
          var indexA = categoryOrder.indexOf(a.name);
          var indexB = categoryOrder.indexOf(b.name);

          // If a category is not in the list, put it at the end
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
        setCategories(sortedCategories);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchCategories();
  }, [propCategories]);

  // Effect to scroll active category into view in the navigation
  useEffect(() => {
    if (activeCategory && scrollContainerRef.current) {
      // Find the active element by name attribute (case-insensitive)
      var activeElements = Array.from(scrollContainerRef.current.querySelectorAll('[data-category]'));
      var activeElement = activeElements.find(el => {
        var categoryName = el.getAttribute('data-category');
        return categoryName && categoryName.toLowerCase() === activeCategory.toLowerCase();
      });
      if (activeElement) {
        // Calculate position to scroll to
        var containerWidth = scrollContainerRef.current.offsetWidth;
        var elementLeft = activeElement.offsetLeft;
        var elementWidth = activeElement.offsetWidth;

        // Center the element in the scrollable area
        var scrollToPosition = elementLeft - containerWidth / 2 + elementWidth / 2;
        scrollContainerRef.current.scrollTo({
          left: scrollToPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [activeCategory, categories]);

  // Function to handle category selection
  var handleCategoryClick = (categoryName, e) => {
    e.preventDefault();
    e.stopPropagation(); // Stop event propagation

    // Make sure we're calling the parent callback
    if (typeof onCategorySelect === 'function') {
      onCategorySelect(categoryName); // Notify parent component about the selected category
    }
  };

  // Check if a category is active, with case-insensitive comparison
  var isCategoryActive = categoryName => {
    if (!activeCategory || !categoryName) return false;
    return categoryName.toLowerCase() === activeCategory.toLowerCase();
  };

  // Mouse/Touch event handlers for horizontal scrolling
  var handleMouseDown = e => {
    if (!scrollContainerRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };
  var handleTouchStart = e => {
    if (!scrollContainerRef.current) return;
    setIsDragging(true);
    setStartX(e.touches[0].pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };
  var handleMouseMove = e => {
    if (!isDragging || !scrollContainerRef.current) return;
    e.preventDefault();
    var x = e.pageX - scrollContainerRef.current.offsetLeft;
    var walk = (x - startX) * 2; // Scroll speed multiplier
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };
  var handleTouchMove = e => {
    if (!isDragging || !scrollContainerRef.current) return;
    var x = e.touches[0].pageX - scrollContainerRef.current.offsetLeft;
    var walk = (x - startX) * 2; // Scroll speed multiplier
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };
  var handleMouseUp = () => {
    setIsDragging(false);
  };
  var handleMouseLeave = () => {
    setIsDragging(false);
  };
  if (loading) return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center py-4"
  });
  if (error) return /*#__PURE__*/React.createElement("div", {
    className: "bg-red-100 p-4 rounded"
  }, "Error loading categories: ", error);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full px-6 !bg-[#F9F9F9]"
  }, categories.length === 0 ? /*#__PURE__*/React.createElement("p", {
    className: "text-gray-300"
  }, "No categories found") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4 mt-[1.4rem]"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[#060708] uppercase text-[1.6rem] font-zoom-pro-compact  font-bold "
  }, _('Menu'))), /*#__PURE__*/React.createElement("div", {
    ref: scrollContainerRef,
    className: "overflow-x-auto flex flex-row gap-[1.6rem] py-2 pr-4 cursor-grab scrollbar-hide",
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onMouseLeave: handleMouseLeave,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleMouseUp
  }, categories.map(category => {
    var isActive = isCategoryActive(category.name);
    return /*#__PURE__*/React.createElement("div", {
      key: category.urlKey || category.name,
      className: "flex-shrink-0 flex flex-col items-center whitespace-nowrap text-[1.6rem]",
      "data-category": category.name
    }, /*#__PURE__*/React.createElement("a", {
      href: "#mobile-category-".concat(category.name.toLowerCase().replace(/\s+/g, '-')),
      onClick: e => handleCategoryClick(category.name, e),
      className: "block uppercase ".concat(isActive ? 'text-[#000] font-[500] font-zoom-pro-compact ' : 'text-[#6c6e71] font-normal font-zoom-pro-compact')
    }, language === 'ar' ? category.nameAr || category.name : category.name), /*#__PURE__*/React.createElement("div", {
      className: "mt-2 rounded-full h-1 transition-all duration-300 ".concat(isActive ? 'bg-[#F8F8F8] w-[3rem]' : 'bg-transparent w-0')
    }));
  }))));
}
export default MenuNavigationMobile;